import styled from 'styled-components';

export const PlotArea = styled.div`
  height: 35vh;
  display: flex;
  flex-direction: row;
`;

export const PlotAreaMargin = styled.div`
  height: 35vh;
  width: ${props => props.margin};
`;

export const PlotAreaWrapper = styled.div`
  height: 55vh;
`;
